import { Controller } from "@hotwired/stimulus"

// Survol horizontal : moitié gauche → team-2, moitié droite → team-3 (au-dessus de team-main).
export default class extends Controller {
  move(event) {
    const rect = this.element.getBoundingClientRect()
    const x = event.clientX - rect.left
    const ratio = rect.width > 0 ? x / rect.width : 0.5
    this.element.dataset.teamPhotoHoverState = ratio < 0.5 ? "left" : "right"
  }

  leave() {
    delete this.element.dataset.teamPhotoHoverState
  }
}
